<template>
    <div class="backboard use-pointer" @click="backclick" :style="{ left: '0px', top: '0px', width: '100vw', height: '100vh', }">
        <div class="popupboard unselectable" @click="popupclick" :style="popupStyle">
            <div class="popupboard-scroller" ref="popupBoard">
                <span class="popupboard-title wf-roundgothic" :style="{ color: titleColor, }">{{taglabel}}</span>
                <div :class="scrollClassName" v-if="messages" ref="contentsArea">
                    <div v-for="(value, index) in messages" :key="index">
                        <h3 v-if="value.title">{{value.title}}</h3>
                        <a style="font-size: xx-small;" :href="value.href" v-if="value.href">{{value.hreftitle}}</a>
                        <div style="display: block; position: relative; width: 100%; left: 0;">
                            <div v-if="value.message" class="messageStyle" :style="value.styles">{{value.message}}</div>
                            <div v-if="value.html" class="messageStyle" :style="value.styles" v-html="value.html"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SVGBPulldown from "@/components/SVGBPulldownSlot"
export default {
name: "LicenseView",
  components: {SVGBPulldown},
  props: {
    ppwidth: {
      type: Number,
      default: null
    },
    ppheight: {
      type: Number,
      default: null
    },
    taglabel: {
      type: String,
      default: '情報'
    },
    messages: {
      type: Array,
      default: () => {
        return [
        {
          styles: {},
          title: 'ちょい読み (Web 1.0.0.0）',
          message:`Copyright (c) 2019 Choiyomi Team

`
        },
        {
          styles: {},
          title: `MIT Licensev, Copyright (c) 2016 Alexander Avakov

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
`}
]
      },
    },
    edgeColor: {
      type: String,
      default: '#230d04',
    },
    titleColor: {
      type: String,
      default: '#f6f7ff',
    },
    noAnimate: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      scrollFlag: false,
     };
  },
  computed: {
    popupStyle() {
      return {
        '--ppwidth': (this.isNumber(this.ppwidth) ? this.ppwidth + 'px' : '90vw'),
        '--ppheight': (this.isNumber(this.ppheight) ? this.ppheight + 'px' : '90vh'),
        '--edge-color': this.edgeColor,
      }
    },
    scrollClassName() {
      return (this.scrollFlag && !this.noAnimate) ? 'contents' : 'contents-na'
    },
  },
  methods: {
    backclick() {
      this.$emit('hide')
    },
    popupclick() {
      this.$emit('hide')
    },
  },
  created() {
  },
  mounted() {
    this.$nextTick(()=> {
      this.scrollFlag = this.$refs.popupBoard.clientHeight < this.$refs.contentsArea.clientHeight
    })
  },
}
</script>

<style lang="scss" scoped>
.backboard {
    position: fixed;
    background: rgba(0,0,0,0.05);
    z-index: 100;
}
.popupboard-scroller {
    overflow-y: scroll;
    background-color: rgba(0,0,0,0);
    padding: 1%;
    width: 98%;
    height: 98%;
}

.popupboard {
    position: fixed;
    margin: 0 0 4em 0;
    /*padding: 0.5em 1em;*/
    border: solid 3px var(--edge-color);
    border-radius: 8px 8px 8px 8px;
    text-align: left;
    background: #f6f7ff;
    z-index: 101;
    box-shadow: 0 2px 4px rgba(0,0,0,0.20);
    max-width: 46rem;

    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: var(--ppwidth);
    height: var(--ppheight);
}
.popupboard .popupboard-title {
    position: absolute;
    display: inline-block;
    top: -27px;
    left: 8px;
    padding: 0 9px;
    height: 25px;
    line-height: 25px;
    font-size: 17px;
    background: var(--edge-color);
    /*color: #f6f7ff;*/
    font-weight: bold;
    border-radius: 5px 5px 0 0;
}

.popupboard-contents {
    margin: 0;
    padding: 0.5em 1em;
}

.contents {
    animation: infinity-loop 30s infinite linear 5s both; /* 無限ループアニメーションの設定 */
    display: flex;
    flex-flow: column;
    position: relative;
}
.contents:hover {
    animation-play-state: paused;
    background-color: #ebf1ff;
}

.contents-na {
    display: flex;
    flex-flow: column;
    overflow-y: auto;
    position: relative;
}

@keyframes infinity-loop {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-100%);
  }
}
.wf-roundgothic { font-family: "M PLUS Rounded 1c"; }

.messageStyle {
    font-family: "sans-serif";
    font-size: 1em;
    white-space: pre-wrap;
    width: 100%;
}

/*
.hover-link {
    position: relative;
    display: inline-block;
    transition: .3s;
}

.hover-link::after {
    position: absolute;
    bottom: 0;
    left: 50%;
    content: '';
    width: 0;
    height: 2px;
    background-color: #31aae2;
    transition: .3s;
    transform: translateX(-50%);
}

.hover-link:hover::after{
    width: 100%;
}
*/

</style>